import React from "react";
import { Card, Form, Row, Col } from "react-bootstrap";
import {
  META_TITLE_MAX_LENGTH,
  META_TITLE_MIN_LENGTH,
  META_DESCRIPTION_MAX_LENGTH,
  META_DESCRIPTION_MIN_LENGTH,
} from "../../../../../utils/seoConstants";

const MetaSection = ({ data, onUpdate }) => {
  const safeData = data || { title: "", description: "" };

  const handleChange = (field, value) => {
    onUpdate({
      title: safeData.title || "",
      description: safeData.description || "",
      [field]: value,
    });
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark">
        <h5 className="mb-0 text-dark">SEO Meta Information</h5>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>Meta Title</Form.Label>
              <Form.Control
                type="text"
                value={safeData.title || ""}
                onChange={(e) => handleChange("title", e.target.value)}
                placeholder="Enter page meta title"
                maxLength={META_TITLE_MAX_LENGTH}
              />
              <Form.Text className="text-muted">
                Recommended length: {META_TITLE_MIN_LENGTH}-{META_TITLE_MAX_LENGTH} characters ({(safeData.title || "").length}/{META_TITLE_MAX_LENGTH})
              </Form.Text>
            </Form.Group>
          </Col>
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>Meta Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={safeData.description || ""}
                onChange={(e) => handleChange("description", e.target.value)}
                placeholder="Enter page meta description"
                maxLength={META_DESCRIPTION_MAX_LENGTH}
              />
              <Form.Text className="text-muted">
                Recommended length: {META_DESCRIPTION_MIN_LENGTH}-{META_DESCRIPTION_MAX_LENGTH} characters ({(safeData.description || "").length}/{META_DESCRIPTION_MAX_LENGTH})
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default MetaSection;
